import { BaseKeyframeTween } from "./base-tween";
import RenderManager from "../../rendering/render-manager";

// ----------------------------------------
//                  ZOOM
// ----------------------------------------
class TweenZoom {
    /**
     * 
     * @param {KeyframeTweenZoom} state 
     * @param {KeyframeTweenZoom} target 
     */
    constructor(state, target) {
        this.ease = target.ease;
        this.zoom = target.zoom;

        this.onStart = () => { };

        this.onUpdate = () => {
            RenderManager.activeCamera.ease = state.ease;
            RenderManager.activeCamera.zoom = state.zoom;
        };

        this.onComplete = () => { };
    }
}

class KeyframeTweenZoom extends BaseKeyframeTween {
    constructor({ ease = NaN, zoom = NaN } = {}) {
        super();

        this.ease = ease;
        this.zoom = zoom;
    }

    /**
     * 
     * @param {SlideSettings} slide 
     */
    fromSlide(slide) {
        this.ease = slide.ease;
        this.zoom = slide.zoom;

        return this;
    }


    /**
     * 
     * @param {KeyframeTweenZoom} target 
     * @param {number} time 
     */
    tweenTo(target, time) {
        const tween = new TweenZoom(this, target);

        return new TweenMax(this, time, tween);
    }
}

export { TweenZoom, KeyframeTweenZoom };